module.exports = __webpack_public_path__ + "img/thunderbird.eea9594c.webp";